import { type ForwardedRef, forwardRef } from 'react'

import { TextField } from '@fv/client-components'
import {
  type QuoteReasonPayload,
  quoteSelectionReasonLabels,
  type ReasonType,
} from '@fv/models'

import { RadioItem, type RadioItemProps } from '@/components/inputs/RadioField'
import { Pinline } from '@/components/Pinline'

import { orderedOptions } from './constants'

type Props = {
  value: QuoteReasonPayload
  onChange: (payload: QuoteReasonPayload) => void
}
export const QuoteReasonFormControls = ({ value, onChange }: Props) => {
  return (
    <div>
      {orderedOptions.map(o => (
        <RadioOption
          key={o}
          name="reasonType"
          type={o}
          value={o}
          checked={value.reasonType === o}
          onChange={e =>
            onChange({ ...value, reasonType: e.target.value as ReasonType })
          }
        />
      ))}
      {value.reasonType !== 'other' && <Pinline rule />}
      {value.reasonType === 'other' && (
        <div className="py-4">
          <TextField
            placeholder="Enter your reason here (50 characters max)"
            name="description"
            value={value.description}
            onChange={e => onChange({ ...value, description: e.target.value })}
            maxLength={50}
            className="form-control"
          />
        </div>
      )}
    </div>
  )
}

const RadioOption = forwardRef(
  (
    { type, ...props }: RadioItemProps & { type: ReasonType },
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const label = quoteSelectionReasonLabels[type]
    return (
      <div className="flex flex-col py-3">
        <RadioItem {...props} ref={ref}>
          <div>{label.label}</div>
          {label.desc && (
            <div className="py-1 italic text-gray-400">{label.desc}</div>
          )}
        </RadioItem>
      </div>
    )
  },
)
